// extracted by mini-css-extract-plugin
export default {"zoomModal":"s1-z"};